export const getPaymentType = (state) => state.giving_form.billing.get("paymentType");
export const getPaymentInterval = (state) =>
  state.giving_form.billing.get("paymentInterval");
export const getBillingType = (state) => state.giving_form.billing.get("billingType");
export const getShowAverageAmount = (state) =>
  state.giving_form.billing.get("showAverageAmount");
export const getIsStripeSepaDebit = (state) =>
  state.giving_form.billing.get("isStripeSepaDebit");
